export default {
  isLoading: false,
  isSendFormCompanyBankAccountSettings: false,
  error: null,
  companyBankAccountsSettings: [],
  privatBankState: {
    id: '',
    api_id: '',
    api_token: '',
    bank_alias: '',
  },
  avalBankState: {
    login: '',
    password: '',
    key_file_name: '',
  },
}
